var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgParkingOnsite = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 25,
  fill: "none",
  viewBox: "0 0 24 25"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#222830",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.8 3.9v9.3M13.8 3.9h3c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5h-2.9M.9 21.4v.4c0 .3.2.6.5.6h1.4M10.6 19.2l2.5.6c.3 0 .6.9.6 1.2v.6c0 .4-.2.7-.5.7h-.8M5.9 22.3h4.2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11 19.3H.9v-2.4h8c.2 0 .5.1.6.4zM11.3 23.7a1 1 0 1 0 0-2 1 1 0 0 0 0 2M4.4 23.7a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.9 17v2.4h-5v2-4c0-.2.1-.4 1.3-.4z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 .5h24v24H0z"
})))));
export default SvgParkingOnsite;